import type { AxiosRequestConfig } from 'axios';

/**
 * Deserialize request data that axios double-serialized.
 *
 * Axios stringifies config.data in the response interceptor, so when retrying
 * requests we need to parse it back to avoid sending `"[object Object]"`.
 *
 * @see https://github.com/axios/axios/issues/4994
 *
 * @param config - Axios request config to deserialize
 */
export const deserializeRequestData = (config: AxiosRequestConfig): void => {
  if (typeof config.data === 'string') {
    try {
      config.data = JSON.parse(config.data);
    } catch {
      // Keep as string if not valid JSON (e.g., form data, plain text)
    }
  }
};